import api from "../config/api";

import useAuth from "./useAuth";
import useLogout from "./useLogout";

const useRefreshToken = () => {
  const { setAuth } = useAuth();
  const logout = useLogout();

  const refreshToken = async () => {
    try {
      const res = await api.get("/auth/customer/refresh-token", {
        withCredentials: true,
      });

      const accessToken = res.data.accessToken;
      const customer = res.data.customer;

      setAuth({ accessToken, customer });

      return accessToken;
    } catch (err) {
      logout();
    }
  };

  return refreshToken;
};

export default useRefreshToken;
